/**
 * Call executor only when necessary
 * Kind of throttle function
 *
 * Call the first time. Consecutive call return the same result, until force is request or TTL is reached
 *
 * @example
 * const value = new CacheableResult(() => fetch("http://example.com/today").then(res => res.text()), 4000);
 * setInterval(async () => console.log(await value.read()), 500)
 *
 * @example
 * const value = new CacheableResult(() => new Date(), 4000);
 * setInterval(() => console.log({now: new Date(), lastUpdate: value.read()})), 500);
 */
export default class {
  /**
   * @param {function} executor Function to store the result value
   * @param {number} ttl Time To Live
   */
  constructor(executor, ttl = 0){
    this._executor = executor;
    this._ttl = ttl;
    this._value = undefined;
    this._date = -1;
  }

  read(force){
    const now = performance.now();
    if(force || this._date < 0 || this._ttl > 0 && now > this._date + this._ttl){
      this._date = now;
      this._value = this._executor();
    }

    return this._value;
  }
}
